import React, { useEffect } from 'react'
import axios from "axios";
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid2';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useComparison } from '../../context/ComparisonContext';

export default function ProductSelectionForm() {
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [makes, setMakes] = React.useState(null);
    const [make, setMake] = React.useState(null);
    const [model, setModel] = React.useState(null);
    const [models, setModels] = React.useState(null);
    const [variant, setVariant] = React.useState(null);
    const [variants, setVariants] = React.useState(null);
    const { apiBaseUrl, addComparision } = useComparison();

    useEffect(() => {

        const postData = {
            type: 'ajax',
            action: 'get-makes',
        };
        (async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${apiBaseUrl}/get-brand-list`, postData);
                const products = response.data;
                const updatedProducts = products.map((product, index) => ({
                    ...product,
                    id: index + 1,
                }));
                setMakes(updatedProducts);
            } catch (err) {
                setError('An error occurred while making the request');
            } finally {
                setLoading(false);
            }
        })()

    }, []);

    useEffect(() => {

        if (!make) {
            return;
        }
        const postData = {
            type: 'ajax',
            action: 'get-models',
            brand: make,
        };
        (async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${apiBaseUrl}/get-model-list`, postData);
                setModels(response.data.data);
            } catch (err) {
                setError('An error occurred while making the request');
            } finally {
                setLoading(false);
            }
        })()

    }, [make]);

    useEffect(() => {
        if (!model) {
            return;
        }
        const postData = {
            type: 'ajax',
            action: 'get-variants',
            model: model,
        };
        (async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${apiBaseUrl}/get-variant-list`, postData);
                setVariants(response.data.data);
            } catch (err) {
                setError('An error occurred while making the request');
            } finally {
                setLoading(false);
            }
        })()

    }, [model]);

    useEffect(() => {

        if (!variant) {
            return;
        }


        const postData = {
            type: 'ajax',
            action: 'get-model-basic-details',
            maker: make,
            model: model
        };
        (async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${apiBaseUrl}/get-variant-list`, postData);

                const details = response.data.data.description;

                const data = [
                    { variant: variants[0].variantid, model, details, variants },
                ];

                addComparision(data);
            } catch (err) {
                setError('An error occurred while making the request');
            } finally {
                setLoading(false);
            }
        })()

    }, [variant]);

    const handleMakeChange = (event) => {
        setMake(event.target.value);
    };
    const handleModelChange = (event) => {
        setModel(event.target.value);
    };
    const handleVariantChange = (event) => {
        setVariant(event.target.value);
    };

    return (
        <Card sx={{ maxWidth: 345 }}>
            <CardContent sx={{ bgcolor: '#f9f9f9' }}>
                <Typography gutterBottom variant="h5" component="h4" className='react-card-heading'>
                    Add new compare
                </Typography>
                <Grid container spacing={2} direction="column">
                    <Grid>
                        <FormControl fullWidth sx={{ mt: 1 }} size="small">
                            <InputLabel id="demo-simple-select-label" className='react-select-label'>Make</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={make ?? ""}
                                label="Make"
                                onChange={handleMakeChange}
                                className='react-select-placeholder-item'

                            >
                                {makes ? (makes.map(make => (
                                    <MenuItem value={make.make} key={make.make} className='react-select-item'>{make.make}</MenuItem>
                                ))) : (<MenuItem value={0} className='react-select-item'>No makes</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label" className='react-select-label'>Model</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select2"
                                value={model ?? ""}
                                label="Model"
                                onChange={handleModelChange}
                                className='react-select-placeholder-item'
                            >
                                {models ? (models.map(model => (
                                    <MenuItem value={model.modelslug} key={model.modelslug} className='react-select-item'>{model.model}</MenuItem>
                                ))) : (<MenuItem value={0} className='react-select-item'>No models</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label" className='react-select-label'>Variant</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select3"
                                value={variant ?? ""}
                                label="Variant"
                                onChange={handleVariantChange}
                                className='react-select-placeholder-item'
                            >
                                {variants ? (variants.map(variant => (
                                    <MenuItem value={variant.id} key={variant.id} className='react-select-item'>{variant.variantshortname}</MenuItem>
                                ))) : (<MenuItem value={0} className='react-select-item'>No variants</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    )
}
